import React, {useEffect, useState} from "react";
import {Autocomplete, Box, TextField, Typography} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import AmountWithCurrency from "../layout/AmountWithCurrency";
import {fetchBudgets, selectBudgetsOrSelected} from "../../store/budgetSlice";
import {useTranslation} from "react-i18next";

const BudgetSelect = ({selectedBudgetId, label, onChange, width = "75%", sx, error = false, helperText = null}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const budgets = useSelector(state => selectBudgetsOrSelected(state, selectedBudgetId));
    const [inputText, setInputText] = useState("");

    useEffect(() => {
        dispatch(fetchBudgets());
    }, []);

    const selectedBudget = budgets.find(budget => budget.id === selectedBudgetId);
    const getBudgetAmount = (budget) => {
        if (!budget) return 0;
        const balances = budget.balances ?? [];
        const mainBalance = balances.find((b) => b.currency === budget.currency);
        if (mainBalance && mainBalance.value !== undefined && mainBalance.value !== null) {
            return mainBalance.value;
        }
        return budget.balance ?? 0;
    };

    return (
        <Autocomplete
            sx={{...sx, display: 'inline-flex', width: width}}
            onChange={(event, newSelectedBudget) => {
                onChange(newSelectedBudget ? newSelectedBudget.id : null);
            }}
            options={budgets}
            isOptionEqualToValue={(option, value) =>
                option?.id === value?.id
            }
            getOptionLabel={(budget) => budget ? budget.name : ""}
            value={selectedBudget || null} // Use the wallet object or null
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            renderOption={(props, budget) => (
                <Box {...props} key={budget.id}>
                    <Typography variant='body1'>
                        {budget.name} - (<AmountWithCurrency amount={getBudgetAmount(budget)} currencyId={budget.currency}/>)
                    </Typography>
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onChange={(e) => { setInputText(e.target.value); }}
                    label={label || t("common.labels.budget")}
                    variant="standard"
                    sx={{width: "100%"}}
                    error={!!error}
                    helperText={helperText}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: "off",
                    }}
                />
            )}
        />
    );
};

export default BudgetSelect;